// controls/tel.js — version React Composant + JSON Schema native
import React, { useState, useEffect } from "react";
import { debug } from "utils";
import CommonControls from "./inc/Common";

/**
 * Création d’un champ téléphone conforme JSON Schema draft 2020-12
 */
export function createTelField() {
  return {
    type: "string",
    title: "Téléphone",
    pattern: "^[0-9+()\\s-]{6,20}$",
    minLength: 6,
    maxLength: 20,
    "x-ui": "tel",
    "x-inputMode": "tel",
    "x-placeholder": "",
    "x-displayWidth": "",
  };
}

/**
 * Éditeur du champ téléphone (FieldEditor) — version composant React
 */
export function EditTelField({ field, onChange }) {
  const [min, setMin] = useState(field.minLength ?? 6);
  const [max, setMax] = useState(field.maxLength ?? 20);
  const [pattern, setPattern] = useState(field.pattern || "^[0-9+()\\s-]{6,20}$");
  const [placeholder, setPlaceholder] = useState(field["x-placeholder"] || "");
  const [displayWidth, setDisplayWidth] = useState(field["x-displayWidth"] || "");

  // 🔄 Synchronisation ascendante vers FormBuilder
  useEffect(() => onChange("minLength", min), [min]);
  useEffect(() => onChange("maxLength", max), [max]);
  useEffect(() => onChange("pattern", pattern), [pattern]);
  useEffect(() => onChange("x-placeholder", placeholder), [placeholder]);
  useEffect(() => onChange("x-displayWidth", displayWidth), [displayWidth]);

  return (
    <>
      <CommonControls field={field} onChange={onChange} />

      {/* ---- Longueur minimale ---- */}
      <div className="mb-3">
        <label className="form-label">Longueur minimale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 6"
          value={min}
          onChange={(e) => setMin(Number(e.target.value))}
        />
      </div>

      {/* ---- Longueur maximale ---- */}
      <div className="mb-3">
        <label className="form-label">Longueur maximale</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 20"
          value={max}
          onChange={(e) => setMax(Number(e.target.value))}
        />
      </div>

      {/* ---- Motif (regex) ---- */}
      <div className="mb-3">
        <label className="form-label">Motif de validation (regex)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : ^[0-9+()\\s-]{6,20}$"
          value={pattern}
          onChange={(e) => setPattern(e.target.value)}
        />
        <small className="text-muted">
          Optionnel — pour restreindre les formats autorisés (regex JavaScript).
        </small>
      </div>

      {/* ---- Placeholder ---- */}
      <div className="mb-3">
        <label className="form-label">Texte indicatif (placeholder)</label>
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="ex : +33 6 12 34 56 78"
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
        />
      </div>

      {/* ---- Largeur visuelle ---- */}
      <div className="mb-3">
        <label className="form-label">Largeur du champ (en caractères)</label>
        <input
          type="number"
          className="form-control form-control-sm compact"
          placeholder="ex : 20"
          value={displayWidth}
          onChange={(e) => setDisplayWidth(e.target.value)}
        />
      </div>
    </>
  );
}

/**
 * Compatibilité avec le FieldEditorRegistry
 */
export const editTelField = (props) => <EditTelField {...props} />;
/* =========================================================
   🧩 FRONT — rendu du champ téléphone
   ========================================================= */
export const RenderTelField = ({
  field,
  value,
  onChange,
  className,
  isReadOnly,
  errors   // valeur string éventuelle : "Champ requis"
}) => {

  const placeholder = field["x-placeholder"] || "";
  const inputMode = field["x-inputMode"] || "tel";
  const displayWidth = field["x-displayWidth"] || "";
  const minLength = field.minLength ?? 6;
  const maxLength = field.maxLength ?? 20;
  const pattern = field.pattern || "^[0-9+()\\s-]{6,20}$";

  const isRequired =
    field["x-effective-required"] === true ||
    field["x-required"] === true;
  return (
    <div
      className={`
        fb-field fb-tel
        ${isRequired ? "fb-required" : ""}
        ${field["x-bloc-class"] || ""}
        ${className || ""}
        
      `}
    >

      {/* Label */}
      {field.title && (
        <label className={`form-label`}>
          {field.title}
        </label>
      )}

      {/* Input tel */}
      <input
        type="tel"
        className={`
          form-control
          ${field["x-control-class"] || ""}
          ${errors ? "is-invalid" : ""}
        `}
        placeholder={placeholder}
        inputMode={inputMode}
        pattern={pattern}
        minLength={minLength}
        maxLength={maxLength}
        size={displayWidth || undefined}
        value={value || ""}
        readOnly={isReadOnly}
        onChange={(e) => onChange?.(e.target.value)}
      />

      {/* Message d’erreur */}
      {/* errors && (
        <div className="invalid-feedback d-block mt-1">
          {debug(errors)}
        </div>
      ) */}

    </div>
  );
};
